import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AttachmentType } from '@core/models/attachment-type';
import { FormControl, Validators } from '@angular/forms';

@Component({
	selector: 'app-file-type-selection',
	templateUrl: './file-type-selection.component.html',
	styleUrls: ['./file-type-selection.component.scss']
})
export class FileTypeSelectionComponent implements OnInit {

	@Input() attachmentTypes: AttachmentType[];

	attachmentType = new FormControl('', Validators.required);

	constructor(public activeModal: NgbActiveModal) { }

	ngOnInit(): void {
	}

}
